// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable react/destructuring-assignment, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React, { PureComponent, ReactNode } from "react"
import { connect } from "react-redux"
import classNames from "classnames"
// @ts-expect-error: Flow to TS migration.
import type { Connector } from "react-redux"
import CloseByKey from "@kiwicom/nitro/lib/components/CloseByKey"

import translate from "../../../../app/scripts/tools/translate"
import { handleBlockScrollBody } from "../../utils/scrollUtils"
import { isMobileSelector } from "../../services/window"
import { FormattedMessage } from "react-intl"

type OwnProps = {
  onClose: () => void
  onKeyDown: (arg1: KeyboardEvent) => void
  children: ReactNode
  wide?: boolean
  closable?: boolean
  closeOnOverlayClick?: boolean
  passedClasses?: string | null | undefined
  modalID?: string
}

type Props = OwnProps & {
  isMobile: boolean
}

class ModalBody extends PureComponent<Props> {
  static defaultProps = {
    wide: false,
    closable: true,
    passedClasses: null,
    closeOnOverlayClick: false,
    modalID: "modal-0-id-0",
  }

  componentDidMount() {
    this.setScrollable(true)
  }

  componentWillUnmount() {
    this.setScrollable(false)
  }

  setScrollable = (value: boolean) => {
    if (this.props.isMobile) {
      handleBlockScrollBody(value)
    }
  }

  handleOverlayClose = () => {
    if (this.props.closeOnOverlayClick) {
      this.props.onClose()
    }
  }

  render() {
    const {
      onClose,
      onKeyDown,
      children,
      wide,
      closable,
      passedClasses = "",
      modalID,
      isMobile,
    } = this.props

    return (
      <CloseByKey onClose={closable ? onClose : () => {}}>
        <div
          className={classNames("Modal", passedClasses)}
          data-test="Modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby={modalID}
        >
          <div onClick={this.handleOverlayClose} className="Modal-content-wrap">
            {closable && isMobile && (
              <div onClick={(e) => e.stopPropagation()} className="Modal-header spShadow">
                <span
                  onClick={onClose}
                  // @ts-expect-error: Flow to TS migration.
                  onKeyDown={onKeyDown}
                  role="button"
                  // @ts-expect-error: Flow to TS migration.
                  tabIndex="0"
                  className="Modal-header-close"
                >
                  <FormattedMessage id="common.close" defaultMessage="Close" />
                </span>
              </div>
            )}

            <div
              onClick={(e) => e.stopPropagation()}
              className={classNames("Modal-content", {
                wide,
              })}
            >
              {closable && !isMobile && (
                <span
                  onClick={onClose}
                  // @ts-expect-error: Flow to TS migration.
                  onKeyDown={onKeyDown}
                  className="Modal-close"
                  data-test="Modal-close"
                  role="button"
                  aria-label={translate("common.close")}
                  // @ts-expect-error: Flow to TS migration.
                  tabIndex="0"
                />
              )}
              {children}
            </div>
          </div>
        </div>
      </CloseByKey>
    )
  }
}

const connector: Connector<OwnProps, Props> = connect((state) => ({
  isMobile: isMobileSelector(state),
}))

export default connector(ModalBody)
